import React, { createContext, useCallback, useContext, useState } from "react";

interface FeedbackContextValue {
    isOpen: boolean;
    formType: string;
    onCloseFn: (() => void) | null;
    triggerFeedback: (formType: string, onClose?: () => void) => void;
    closeFeedback: () => void;
}

const FeedbackContext = createContext<FeedbackContextValue>({
    isOpen: false,
    formType: "",
    onCloseFn: null,
    triggerFeedback: () => {},
    closeFeedback: () => {},
});

export function FeedbackProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [formType, setFormType] = useState("");
    const [onCloseFn, setOnCloseFn] = useState<(() => void) | null>(null);

    const triggerFeedback = useCallback((formType: string, onClose?: () => void) => {
        setFormType(formType);
        setOnCloseFn(() => onClose ?? null);
        setIsOpen(true);
    }, []);

    const closeFeedback = useCallback(() => {
        setIsOpen(false);
        if (onCloseFn) {
            onCloseFn();
        }
        setOnCloseFn(null);
        setFormType("");
    }, [onCloseFn]);

    return (
        <FeedbackContext.Provider value={{ isOpen, formType, onCloseFn, triggerFeedback, closeFeedback }}>
            {children}
        </FeedbackContext.Provider>
    );
}

export function useFeedback() {
    return useContext(FeedbackContext);
}
